import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PostLeadRequestComponent } from './post-lead-request.component';
import { PostLeadRequestListComponent } from './post-lead-request-list/post-lead-request-list.component';
import { PostEmailUsageZoneComponent } from './post-email-usage-zone/post-email-usage-zone.component';
import { PostIpUsageZoneComponent } from './post-ip-usage-zone/post-ip-usage-zone.component';
import { PostPhoneUsageZoneComponent } from './post-phone-usage-zone/post-phone-usage-zone.component';

const routes: Routes = [
  {
    path: '',
    component: PostLeadRequestComponent,
    children: [
      {
        path: 'view-all-post-lead-requests',
        component: PostLeadRequestListComponent
      },
      {
        path: 'post-email-usage-list',
        component: PostEmailUsageZoneComponent
      },
      {
        path: 'post-ip-usage-list',
        component: PostIpUsageZoneComponent
      }, 
      {
        path: 'post-phone-usage-list',
        component: PostPhoneUsageZoneComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PostLeadRequestRoutingModule { }
